<div class="modal-header pb-0">
  <h4 class="modal-title">{{initialState.isinternal ? 'Copy Unique Link' : 'Copy Link to Story'}}</h4>
  <button type="button" (click)="close()" class="close">
    <span aria-hidden="true">
      <svg role="img">
        <use xlink:href="#icon-close"></use>
      </svg></span>
  </button>
</div>
<div class="modal-body" [formGroup]="copyForm">

  <div class="option-wrapper mb-4 pt-0">
  <ng-container *ngIf="!initialState.isinternal">

    <div class="row pt-0 mb-2"> 
      <div class="col-6">
        <!-- <button  class="btns button_style"(click)="publicStory()"><span class="previousbutton">Story Page &nbsp;</span><i class="fa-thin fa-link"></i></button> -->
        <h6>Full Story</h6>
        <p class="description_text">Share everything on page.</p>
      </div>
      <div class="col-6 text-center" >
        <span class="previousbutton" (click)="publicStory()"><i class="fa-regular fa-link"></i></span>
      </div>
    </div>
    
    <div class="row" *ngIf="initialState.isvideo"> 
      <div class="col-6">
        <!-- <button  class="btns button_style"(click)="publicStory()"><span class="previousbutton">Story Page &nbsp;</span><i class="fa-thin fa-link"></i></button> -->
        <h6>Video Only</h6>
        <p class="description_text">Share page with video only.</p>
      </div>
      <div class="col-6 text-center">
        <span class="previousbutton" (click)="publicVideo()"><i class="fa-regular fa-link"></i></span>
      </div>
    </div>

   <hr>
   <ng-container *ngIf="currentUser">
    <div class="headings_of_invite_content row mt-4 mb-3 ml-1">
      <div class="">Personalize Your Link</div>
      <div class="slide_toggle ml-2 mb-2">
          <!-- <mat-slide-toggle  class="toglle_color"  formControlName="addPersonalize">
          </mat-slide-toggle> -->
          <label class="switch">
            <input formControlName="addPersonalize" (change)="onPersonalizeToggleChange()" type="checkbox" tabindex="0" aria-label="Add Personal Message to Shared Page">
            <span  [style.background]="copyForm.controls.addPersonalize.value ? toggle_color : ''" class="slider"></span>
          </label>

      </div>
     </div>


     <ng-container *ngIf="copyForm.value.addPersonalize">
      <!--<div class="row">
        <div class="col-6">
          <h6>First Name</h6>
          <gs-input-material label="First Name" name="First Name" placeholder="First Name" formControlName="firstname" [formControl]="copyForm.controls.firstname" type="text"></gs-input-material>
        </div>
        <div class="col-6">
           <h6>Last Name</h6>
          <gs-input-material label="Last Name" name="Last Name" placeholder="Last Name" formControlName="lastname" [formControl]="copyForm.controls.lastname" type="text"></gs-input-material>
        </div>
      </div>-->
        <div class="row">
          <div class="col-12">
            <h6>Popup Message From You</h6>
            <!-- <textarea class="input__style" formControlName="message" name="" id="" cols="30" rows="4"></textarea> -->
            <gs-area-material
            label=""
            name="Message" placeholder="What happened? Why does it matter?" rows="2"
            cssClass="spacing-lg" formControlName="message" [formControl]="copyForm.controls.message">
        </gs-area-material>
          </div>

         </div>

         <!-- Video Message Section for Public Stories -->
         <div class="row" *ngIf="copyForm.value.addPersonalize">
           <div class="col-12">
             <div class="mb-1 author_container">

             </div>
           </div>
         </div>

         <!-- Video Preview Container for Public Stories -->
         <div class="remark-box" *ngIf="copyForm.value.addPersonalize" [ngClass]="{'show': isDisplayVideoMenu, 'hide': !isDisplayVideoMenu}">
           <div class="close__popup_Design">
             <button class="btn btn-trans ml-3" (click)="isDisplayVideoMenu = false ; show_video = false">
               <svg role="img" class="text-pink">
                 <use xlink:href="#icon-expand"></use>
               </svg>
             </button>
           </div>
           <div class="video_container" *ngIf="show_video && isDisplayVideoMenu">
             <video class="video_player" #videoPlayer controls width="100%"></video>
             
             <div class="below_content">
               <div class="add_message" (click)="removeVideo()" [style.color]="is_video ? '#1db6bb' : ''">
                 <h6> Remove Video  <span><i class="ml-1 fa-solid fa-video"></i></span></h6>
               </div>
             </div>
           </div>
         </div>

         <div class="row genarate_btn_continer" *ngIf="!isShow">
          <button [style.background]="primaryColor ? primaryColor : ''" class="btn genarate_btn btn-pink min-width" type="submit" [disabled]="disabled || copyForm.invalid" (click)="genrarateLink()">Get Link to Share</button>
         </div>
         <div class="row genarate_btn_continer" *ngIf="isShow">
          <button class="btn min-width" type="submit"  (click)="CopyLink()">Copy link
            &nbsp; <span><i class="fas fa-link" style="color: #1579f6"></i></span>
          </button>
         </div>

     </ng-container>
  
   </ng-container>


  </ng-container>

  <ng-container *ngIf="initialState.isinternal">
    <div class="row"> 
      <div class="col-6">
        <!-- <button  class="btns button_style"(click)="publicStory()"><span class="previousbutton">Story Page &nbsp;</span><i class="fa-thin fa-link"></i></button> -->
        <h6>Unique Story Link</h6>
        <p class="description_text">Share everything on page. Will NOT display on socials.</p>
      </div>
      <div class="col-6">
        <span class="previousbutton" (click)="internalStory()"><i class="fa-regular fa-link"></i></span>
      </div>
    </div>
    <div class="row" *ngIf="initialState.isvideo"> 
      <div class="col-6">
        <!-- <button  class="btns button_style"(click)="publicStory()"><span class="previousbutton">Story Page &nbsp;</span><i class="fa-thin fa-link"></i></button> -->
        <h6>Unique Video Link</h6>
        <p class="description_text">Link displays a page with video only. Will NOT display on socials.</p>
      </div>
      <div class="col-6">
        <span class="previousbutton" (click)="internalVideo()"><i class="fa-regular fa-link"></i></span>
      </div>
    </div>
    <div class="headings_of_invite_content row mb-3 ml-1">
      <div class=""> Add Personal Message to Shared Page</div>
      <div class="slide_toggle ml-2 mb-2">
          <!-- <mat-slide-toggle  class="toglle_color" color="accent" formControlName="addPersonalize">
          </mat-slide-toggle> -->

          <label class="switch">
            <input formControlName="addPersonalize" (change)="onPersonalizeToggleChange()" type="checkbox" tabindex="0" aria-label="Add Personal Message to Shared Page">
            <span  [style.background]="copyForm.controls.addPersonalize.value ? toggle_color : ''" class="slider"></span>
          </label>
      </div>
     </div>
    <div class="row" *ngIf="copyForm.value.addPersonalize">
      <div class="col-6">
        <!-- <h6>First Name</h6> -->
        <gs-input-material label="First Name" name="First Name" placeholder="First Name" formControlName="firstname" [formControl]="copyForm.controls.firstname" type="text"></gs-input-material>
      </div>
      <div class="col-6">
        <!-- <h6>Last Name</h6> -->
        <gs-input-material label="Last Name" name="Last Name" placeholder="Last Name" formControlName="lastname" [formControl]="copyForm.controls.lastname" type="text"></gs-input-material>
      </div>
    </div>
         <div class="row" *ngIf="copyForm.value.addPersonalize">
        <div class="col-12">
          <h6>Message</h6>
          <!-- <textarea class="input__style" formControlName="message" name="" id="" cols="30" rows="4"></textarea> -->
          <gs-area-material
          label=""
          name="Message" placeholder="What happened? Why does it matter?" rows="2"
          cssClass="spacing-lg" formControlName="message" [formControl]="copyForm.controls.message">
      </gs-area-material>
        </div>

       </div>

       <!-- Video Message Section -->
       <div class="row" *ngIf="copyForm.value.addPersonalize">
         <div class="col-12">
         </div>
       </div>

       <!-- Video Preview Container -->
       <div class="remark-box" *ngIf="copyForm.value.addPersonalize" [ngClass]="{'show': isDisplayVideoMenu, 'hide': !isDisplayVideoMenu}">
         <div class="close__popup_Design">
           <button class="btn btn-trans ml-3" (click)="isDisplayVideoMenu = false ; show_video = false">
             <svg role="img" class="text-pink">
               <use xlink:href="#icon-expand"></use>
             </svg>
           </button>
         </div>
         <div class="video_container" *ngIf="show_video && isDisplayVideoMenu">
           <video class="video_player" #videoPlayer controls width="100%"></video>
           
           <div class="below_content">
             <div class="add_message" (click)="removeVideo()" [style.color]="is_video ? '#1db6bb' : ''">
               <h6> Remove Video  <span><i class="ml-1 fa-solid fa-video"></i></span></h6>
             </div>
           </div>
         </div>
       </div>
       <div class="row genarate_btn_continer" *ngIf="copyForm.value.addPersonalize && !isShow">
        <button class="btn genarate_btn btn-pink min-width" type="submit" [disabled]="disabled || copyForm.invalid" (click)="genrarateLink()">Create Link</button>
       </div>
       <div class="row genarate_btn_continer" *ngIf="isShow">
        <button class="btn min-width" type="submit"  (click)="CopyLink()">Copy link
          &nbsp; <span><i class="fas fa-link" style="color: #1579f6"></i></span>
        </button>
       </div>
  </ng-container>
  </div>
</div>

<mux-uploader id="my-uploader-gs-copy-link" style="display: none;">
  <button class="btn" type="button" slot="file-select" aria-label="Select a file">Pick a file</button>
</mux-uploader>

<!-- <iframe src="http://localhost:4200/?&showHeader=true&showtagheader=true" height="900px" width="100px" frameborder="0"></iframe> -->
